import Link from 'next/link';
import { useTranslations } from 'next-intl';

import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import { UiKitLabelBase } from '@/fo/ui/kit/label/base';
import { UiKitLinkCopy } from '@/fo/ui/kit/link/copy';

import { ArticlePost } from '../../types';

import { styles } from './PostFooter.styles';

export interface PostFooterProps {
  post: ArticlePost;
  backLink: string;
  currentLink: string;
}

export function PostFooter({ post, backLink, currentLink }: PostFooterProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base()}>
      {post.topics?.length > 0 && (
        <div className={slots.tags()}>
          {post.topics?.map((tag) => (
            <UiKitLabelBase
              as={tag.href ? 'link' : 'div'}
              className={slots.tag()}
              key={tag.id}
              style={
                tag.color
                  ? {
                      backgroundColor: tag.color,
                      color: 'var(--color-white)'
                    }
                  : {}
              }
              color={tag.color ? undefined : 'yellow'}
              uppercase
              href={tag.href ?? ''}
            >
              {tag.name}
            </UiKitLabelBase>
          ))}
        </div>
      )}
      <div className={slots.footer()}>
        <Link
          href={backLink}
          className={slots.footerButton()}
        >
          <div className={slots.backIcon()}>
            <ArrowIcon />
          </div>
          <span>{t('article.page.post.back')}</span>
        </Link>
        <UiKitLinkCopy
          link={currentLink}
          needOrigin
          textClassName={slots.share()}
        />
      </div>
    </div>
  );
}
